import {
  CanCreate,
  CanDelete,
  CanUpdate,
  showWhenPermission,
  CanRead,
} from '@/shared/components/security';
import ZendeskHelp from '@/shared/components/ZendeskHelp';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import api from '@/shared/api';
import config from '@/config';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa';
import YesNoModal from '@/shared/components/YesNoModal';
import HandleHttpError from '@/shared/services/HandleHttpError';
import intlShape from '@/shared/utils/intlShape';
import { CopyIcon } from '@/shared/components/Icons';
import messages from './tenantRoleMessages';
import TenantRoleConfigModal from './TenantRoleConfigModal';
import AddTenantRoleDropdownButton from './AddTenantRoleDropdownButton';
import showWhenFeature from '@/shared/components/security/showWhenFeature';

class TenantRoleContainer extends Component {
  state = {
    items: [],
    editModal: null,
    roleToDelete: null,
  };

  componentDidMount() {
    api.base.get(`${config.appUrls.api}/api/TenantRole/Settings`).then(({ data }) => {
      this.setState({ items: data.sort(dynamicSort('name')) });
    });
  }

  openEditDialog = model => {
    this.setState({
      editModal: model,
    });
  };
  onDelete = role => {
    this.setState({ roleToDelete: role });
  };
  deleteRole() {
    const { roleToDelete } = this.state;
    const { intl } = this.props;
    if (!roleToDelete || !roleToDelete.id) return;
    return api.base.delete(`${config.appUrls.api}/api/TenantRole/${roleToDelete.id}`).then(() => {
      this.setState(({ items }) => ({
        items: items.filter(x => x.id !== roleToDelete.id),
        roleToDelete: null,
      }));
    }, HandleHttpError(intl));
  }
  updateRole = role => {
    if (!role || !role.id) {
      this.setState({ editModal: null });
      return;
    }

    this.setState(({ items }) => {
      let found = false;
      const newItems = items.map(x => {
        if (x.id !== role.id) return x;
        found = true;
        return { ...x, ...role };
      });

      return {
        items: (found ? newItems : [...items, role]).sort(dynamicSort('name')),
        editModal: null,
      };
    });
  };

  roleNameExists = name => {
    const { items } = this.state;
    return items.some(x => x.name === name);
  };

  copyRole = role => {
    let name = '';
    for (let i = 2; i < 20; i++) {
      name = `${role.name} ${i}`;
      if (!this.roleNameExists(name)) break;
    }
    this.openEditDialog({ ...role, permissions: { ...role.permissions }, id: undefined, name });
  };

  render() {
    const { items, editModal, roleToDelete } = this.state;
    const { intl } = this.props;
    return (
      <div>
        <div className="panel">
          <div className="panel-heading">
            <h3 className="panel-title">
              <span>
                <FormattedMessage {...messages.TenantRoles} />
                <ZendeskHelp article="16185959488156" className="margin5L" />
              </span>
            </h3>
            <CanCreate on="CompanyOwn">
              <div className="panel-buttons">
                <AddTenantRoleDropdownButton intl={intl} onOpenEditModal={this.openEditDialog} />
              </div>
            </CanCreate>
          </div>
        </div>
        <div>
          <table className="table table-grid table-hover margin5T">
            <thead>
              <tr>
                <th>
                  <FormattedMessage {...messages.Name} />
                </th>
                <th />
                <th />
              </tr>
            </thead>
            <tbody>
              {items.map(x => (
                <tr key={x.id}>
                  <td>{x.name}</td>
                  <td />
                  <td className="text-right">
                    <div className="flex-row-nowrap">
                      <CanCreate on="CompanyOwn">
                        <a
                          className="btn btn-xs btn-icon"
                          title={intl.formatMessage(messages.Copy)}
                          onClick={() => this.copyRole(x)}
                        >
                          <CopyIcon />
                        </a>
                      </CanCreate>
                      <CanRead on="CompanyOwn">
                        <a className="btn btn-xs btn-icon" onClick={() => this.openEditDialog(x)}>
                          <FaPencilAlt className="fa-fw" />
                        </a>
                      </CanRead>
                      <CanDelete on="CompanyOwn">
                        <a className="btn btn-xs btn-icon" onClick={() => this.onDelete(x)}>
                          <FaTrashAlt className="fa-fw" />
                        </a>
                      </CanDelete>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {editModal && (
          <TenantRoleConfigModal value={editModal} onClose={value => this.updateRole(value)} />
        )}
        {roleToDelete && (
          <YesNoModal
            intl={intl}
            show
            title={intl.formatMessage(messages.DeleteConfirmationTitle)}
            message={intl.formatMessage(messages.DeleteRoleConfirmationMsg)}
            onNo={() =>
              this.setState(state => ({
                ...state,
                roleToDelete: null,
              }))
            }
            onSave={() => this.deleteRole()}
          />
        )}
      </div>
    );
  }
}

TenantRoleContainer.propTypes = {
  intl: intlShape.isRequired,
};

export default showWhenPermission('CompanyOwn', 'read')(injectIntl(TenantRoleContainer));
